import { render, staticRenderFns } from "./PriceCreate.vue?vue&type=template&id=2e097530&"
import script from "./PriceCreate.vue?vue&type=script&lang=js&"
export * from "./PriceCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports